import { RESOURCE_NAME } from '@esentai/core/features/stores/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadStores = authorizeIf(canRead(RESOURCE_NAME));
export const canReadStore = authorizeIf(canRead(RESOURCE_NAME));
export const canCreateStore = authorizeIf(canCreate(RESOURCE_NAME));
export const canUpdateStore = authorizeIf(canUpdate(RESOURCE_NAME));

// TODO set permission for campaign statistic
export const canReadStoresStatistics = () => true;
